import { TradeOrgPages } from "../types/tradeorgPages.ts";
import List from "./components/List.tsx";
import OrgLinks from "./components/OrgLinks.tsx";
import Title from "./components/Title.tsx";
import { Layout } from "./Layout.tsx";

const Nbas = () => {
  const pageName = TradeOrgPages.NBAS;
  return (
    <Layout
      left={
        <>
          <Title title="Norsk Bransjeforening for ATV og Snøscooter" subTitle="Det forplikter å være medlem i NBAS!" />
          <div className="mt-40 pb-40">
            <p>
              Kjøp av ATV og snøscooter er for mange en stor investering, og uforutsette kostnader bør unngås. Å kjøpe
              snøscooter av en faghandler som er medlem i NBAS gir deg forutsigbarhet, trygghet og et sikkert kjøretøy.
            </p>
            <p>
              NBAS-forhandlerne har et bredt tilbud av brukt ATV og snøscooter, samt den riktige kompetansen for å
              veilede deg i kjøpsprosessen, slik at du skaffer deg det terrengkjøretøyet som passer deg og ditt behov
              best.
            </p>
            <br />
            <List
              title="Det er mange gode grunner til å kjøpe brukt ATV og snøscooter fra en autorisert NBAS-faghandler:"
              listElements={[
                "Kjøretøyet er gjennomgått av faghandlerens verksted, som oppfyller produsentenes vilkår og krav.",
                "En slik verkstedkontrollert ATV/snøscooter gir deg som kunde økt sikkerhet.",
                "ATV/snøscooter leveres med en garanti.",
                "NBAS-faghandleren garanterer riktig servicehistorikk og kilometerstand.",
                "Kjøretøyet er fri for heftelser.",
                "Du får innbyttemuligheter på din ATV/snøscooter.",
                "Du blir tilbudt konkurransedyktig finansiering og forsikring.",
                "NBAS-faghandleren benytter oppdatert kjøpekontrakt, i henhold til den nye forbrukerkjøpsloven.",
              ]}
            />
            <p className="mt-16 mb-0 text-m">
              <a href="https://nbas.as/medlemmer/" target="_blank" rel="noopener">
                Se om selgeren er medlem hos NBAS
              </a>
            </p>
          </div>
        </>
      }
      right={<OrgLinks pageName={pageName} />}
    />
  );
};

export default Nbas;
